// extracted by mini-css-extract-plugin
export default {"tab":"Tab_tab__+suja","disabled":"Tab_disabled__4cFdE","buttonsGroup":"Tab_buttonsGroup__oHdn9","activeTab":"Tab_activeTab__wdTK8","default":"Tab_default__bq7KQ"};